// src/contexts/MaintenanceContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MaintenanceContextType {
  isUnderMaintenance: boolean;
  maintenanceMessage: string;
  setMaintenanceMode: (isActive: boolean, message?: string) => void;
}

const MaintenanceContext = createContext<MaintenanceContextType | undefined>(undefined);

export const MaintenanceProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState(
    'Website is currently under maintenance. Some features may be unavailable.'
  );

  const setMaintenanceMode = (isActive: boolean, message?: string) => {
    setIsUnderMaintenance(isActive);
    if (message) setMaintenanceMessage(message);
  };

  return (
    <MaintenanceContext.Provider
      value={{
        isUnderMaintenance,
        maintenanceMessage,
        setMaintenanceMode
      }}
    >
      {children}
    </MaintenanceContext.Provider>
  );
};

export const useMaintenanceStatus = (): MaintenanceContextType => {
  const context = useContext(MaintenanceContext);
  if (context === undefined) {
    throw new Error('useMaintenanceStatus must be used within a MaintenanceProvider');
  }
  return context;
};
